import axiosInstance from '@/shared/api/axios';
import type {
  ApiNotification,
  ApiNotificationsGetResponse,
  ApiNotificationsReadAllPostResponse,
  ApiNotificationsUnreadCountGetResponse,
} from '@/shared/types/api/notifications';

const SUPPORTED_LANGS = ['uz', 'ru', 'en'] as const;
type SupportedLang = (typeof SUPPORTED_LANGS)[number];

/** Maps an i18n language (e.g. "ru-RU") to a supported backend lang, falling back to uz. */
export const resolveNotificationLang = (lang?: string): SupportedLang => {
  const base = (lang ?? '').toLowerCase().split('-')[0] ?? '';
  return (SUPPORTED_LANGS as readonly string[]).includes(base)
    ? (base as SupportedLang)
    : 'uz';
};

export const apiNotificationsGet = async (
  page?: number,
  lang?: string,
  pageSize?: number,
): Promise<ApiNotificationsGetResponse> => {
  const { data } = await axiosInstance.get<ApiNotificationsGetResponse>('/notifications', {
    params: {
      ...(page != null ? { page } : {}),
      ...(pageSize != null ? { page_size: pageSize } : {}),
      lang: resolveNotificationLang(lang),
    },
  });
  return data;
};

export const apiNotificationsUnreadCountGet =
  async (): Promise<ApiNotificationsUnreadCountGetResponse> => {
    const { data } = await axiosInstance.get<ApiNotificationsUnreadCountGetResponse>(
      '/notifications/unread-count',
    );
    return data;
  };

export const apiNotificationReadPost = async (id: string): Promise<ApiNotification> => {
  const { data } = await axiosInstance.post<ApiNotification>(`/notifications/${id}/read`);
  return data;
};

export const apiNotificationsReadAllPost =
  async (): Promise<ApiNotificationsReadAllPostResponse> => {
    const { data } = await axiosInstance.post<ApiNotificationsReadAllPostResponse>(
      '/notifications/read-all',
    );
    return data;
  };
